import React from 'react';
import './AboutUs.css';
import { images } from '../../constants';

const AboutUs = () => (
  <div className='app__aboutus app__bg flex__center section__padding' id="about">
    <div className="app__aboutus-overlay flex__center">
      <img src={images.aboutuscover} alt="sk letter" />
    </div>

    <div className="app__aboutus-content">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <img src={images.spoon} alt="about spoon" className="spoon_img" />
        <p className="p__opensans">
          Born out of a passion for traditional flavors and warm hospitality, Kamatha brings the rich culinary heritage of Sri Lanka to Australia. Our menu is a celebration of vibrant spices, age-old recipes, and home-style cooking that reflects the diverse regions of the island — from the fiery curries of the south to the fragrant rice dishes of the central hills.
        </p>
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Our Speciality</h1>
        <img src={images.spoon} alt="about spoon" className="spoon_img" />
        <p className="p__opensans">
          At Kamatha, we believe food is more than just a meal — it’s an experience that connects people and tells a story. That’s why every dish is prepared with care, using the freshest local ingredients and traditional techniques passed down through generations. Whether you're craving a classic kottu roti, hoppers fresh off the pan, or a feast of rice and curry, we promise a dining experience that’s authentic, flavorful, and unforgettable.
        </p>
      </div>
    </div>
  </div>
);

export default AboutUs;
